import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { challengesApi } from '../api/challenges.api'
import type { CreateChallengePayload } from '../types'

export const CHALLENGES_KEY = ['challenges'] as const

export function useChallenges() {
  return useQuery({
    queryKey: CHALLENGES_KEY,
    queryFn: () => challengesApi.fetchAll().then((r) => r.data.data),
  })
}

function useChallengeMutation<TVariables>(mutationFn: (variables: TVariables) => Promise<unknown>) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: CHALLENGES_KEY }),
  })
}

export function useCreateChallenge() {
  return useChallengeMutation((payload: CreateChallengePayload) => challengesApi.create(payload))
}

export function useInviteToChallenge() {
  return useChallengeMutation(({ challengeId, userId }: { challengeId: string; userId: string }) =>
    challengesApi.invite(challengeId, userId)
  )
}

export function useRespondToChallenge() {
  return useChallengeMutation(
    ({ challengeId, answer }: { challengeId: string; answer: 'accept' | 'decline' | 'leave' }) =>
      challengesApi.respond(challengeId, answer)
  )
}
